import { render, staticRenderFns } from "./ModalSetLanguage.vue?vue&type=template&id=e1534744&scoped=true&"
import script from "./ModalSetLanguage.vue?vue&type=script&lang=js&"
export * from "./ModalSetLanguage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1534744",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
